import { useTranslation } from 'react-i18next'
import { CurecallTab, useClickOutside } from '@honestica/curecall-ui'
import { useRef, useState } from 'react'
import { useSession } from 'src/providers/auth.provider'
import { PlanningTabActionsMenu } from './planning-tab-actions-menu.component'

interface PlanningTabItemProps {
  label: string
  isActive: boolean
  onClick: VoidFunction
  onUpdate: VoidFunction
  onDuplicate: VoidFunction
  onDelete?: VoidFunction
  menuClassName?: string
}

export const PlanningTabItem = ({
  label,
  isActive,
  onClick,
  onUpdate,
  onDuplicate,
  onDelete,
  menuClassName,
}: PlanningTabItemProps) => {
  const { t } = useTranslation()
  const { currentUser } = useSession()

  const popoverRef = useRef<HTMLDivElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)
  const hasActions = isActive && !!currentUser?.isAdmin

  useClickOutside({ ref: popoverRef, callBack: () => setIsDropdownOpen(false) })

  const closeDropdownAfter = (action: VoidFunction) => () => {
    action()
    setIsDropdownOpen(false)
  }

  return (
    <CurecallTab
      ref={hasActions ? popoverRef : undefined}
      isActive={isActive}
      onClick={onClick}
      onActionsClick={hasActions ? () => setIsDropdownOpen((open) => !open) : undefined}
      actionsAriaLabel={t('pages.planning.more-action-for-tab', { tabName: label })}
      actionsAriaExpanded={isDropdownOpen}
      dropdownContent={
        hasActions && isDropdownOpen ? (
          <PlanningTabActionsMenu
            className={menuClassName}
            onUpdate={closeDropdownAfter(onUpdate)}
            onDuplicate={closeDropdownAfter(onDuplicate)}
            onDelete={onDelete && closeDropdownAfter(onDelete)}
          />
        ) : undefined
      }
    >
      {label}
    </CurecallTab>
  )
}
